import { defineMessages } from "react-intl"

export const messages = defineMessages({
    balanceTitle: {
        id: "payment_processing.payout_listing.base_statbox.balance_title",
        defaultMessage: "Balance"
    },
    balanceTooltipMessage: {
        id: "payment_processing.payout_listing.base_statbox.balance_tooltip_message",
        defaultMessage: "Upcoming payouts that will be deposited in your bank account once processed.",
    },
    inTransitToBankTitle: {
        id: "payment_processing.payout_listing.base_statbox.in_transit_to_bank_title",
        defaultMessage: "In transit to bank"
    },
    inTransitToBankTooltipMessage: {
        id: "payment_processing.payout_listing.base_statbox.in_transit_to_bank_tooltip_message",
        defaultMessage: "Processing payouts currently on their way to your bank account."
    },
    lastPayoutTitle: {
        id: "payment_processing.payout_listing.base_statbox.last_payout_title",
        defaultMessage: "Last payout"
    },
    lastPayoutTooltipMessage: {
        id: "payment_processing.payout_listing.base_statbox.last_payout_tooltip_message",
        defaultMessage: "Most recent payout successfully deposited in your bank account."
    },
    estimatedAmounts: {
        id: "payment_processing.payout_listing.base_statbox.estimated_amounts_note",
        defaultMessage: "*Estimated amount"
    },

})


// WEBPACK FOOTER //
// ./src/payment-processing/payout-listing/statBoxes/messages.ts